import { test } from 'ramda';

/**
 * 장바구니 API 호출이 필요하지 않은 URL 패턴을 정의한다
 */
const notNeedToCartApiRegexp = [
  '^\/live-commerce\/[^\/]+$' // [YAWEB-1811] 라이브커머스 상세 페이지
];
export const notNeedToCartApi = (path: string): boolean => {
  return notNeedToCartApiRegexp.some((regExp) => test(new RegExp(regExp), path));
};
